import { useDispatch, useSelector } from "react-redux";
import { getCurrentStep, getStepsCount } from "../selectors";
import { setStepsCount, updateToPrevStep } from "../actions";
import useFormState from "../useFormState";

export function useSteps() {
	const dispatch = useDispatch();
	const step = useSelector(getCurrentStep);
	const stepsCount = useSelector(getStepsCount);
	const isLastStep = step === stepsCount - 1;
	const { userExists } = useFormState();

	const isCreateUserStep = !userExists && isLastStep;

	const onPrevStepChange = () => {
		dispatch(updateToPrevStep());
	};

	const onSetStepsCount = (count) => {
		dispatch(setStepsCount(count));
	};

	return {
		onPrevStepChange,
		onSetStepsCount,
		isCreateUserStep,
		isLastStep,
		step,
		stepsCount,
	};
}
